import { BlueBirdTheme } from "@kitbird/core";
import { ReactNode } from "react";
import { ReactComponent as CheckIcon } from "../../assets/icons/check_mark.svg";
import { ReactComponent as CrossIcon } from "../../assets/icons/cross_mark.svg";
import {
  CheckWrapper, ChecklistLineWrapper, ChecklistRow, VerticalLine,
} from "./ChecklistLine.style";

export interface ChecklistDataI {
  key: string | number,
  label: string | ReactNode,
  description: string | ReactNode,
  checkType?: "check" | "cross",
  active?: boolean,
}

export interface ChecklistLineI {
  data: ChecklistDataI[],
}

const { danger, primary, white } = BlueBirdTheme.colors;

const ChecklistLine = ({ data }: ChecklistLineI) => {
  const idHasCross = data.findIndex((item) => item.checkType === "cross");

  const checkBg = (item: ChecklistDataI) => {
    let color = primary["200"];
    if (item.active && item.checkType === "cross") color = danger["500"];
    else if (!item.active && item.checkType === "cross") color = danger["200"];
    else if (item.active) color = primary["500"];
    else if (!item.active) color = primary["200"];
    return color;
  };

  const lineBg = (item: ChecklistDataI, nextItem: ChecklistDataI) => {
    let color1 = "transparent";
    let color2 = "transparent";

    if (item.active && item.checkType === "cross") color1 = danger["500"];
    else if (!item.active && item.checkType === "cross") color1 = `${danger[200]} 40%`;
    else if (item.active) color1 = primary["500"];
    else if (!item.active) color1 = `${primary[200]} 40%`;

    if (nextItem.active && nextItem.checkType === "cross") color2 = danger["500"];
    else if (!nextItem.active && nextItem.checkType === "cross") color2 = `${danger[200]} 40%`;
    else if (nextItem.active) color2 = primary["500"];
    else if (!nextItem.active) color2 = `${primary[200]} 60%`;

    return `linear-gradient(${color1}, ${color2})`;
  };

  return (
    <ChecklistLineWrapper>
      {data.map((item, i) => (
        <div
          key={item.key}
          style={{ display: "flex" }}
        >
          <VerticalLine style={{
            backgroundImage: (i !== data.length - 1 && i >= idHasCross)
              ? lineBg(item, data[i + 1])
              : "none",
          }} />
          <ChecklistRow>
            <CheckWrapper style={{
              backgroundColor: checkBg(item),
            }} >
              {item.checkType === "cross" ? <CrossIcon color={white} /> : <CheckIcon />}
            </CheckWrapper>
            <div>
              {item.label}
              <div>{item.description}</div>
            </div>
          </ChecklistRow>
        </div>
      ))}
    </ChecklistLineWrapper>
  );
};

export default ChecklistLine;
